import React from 'react';
import { useTranslation } from 'react-i18next';
import withMapping from '../../../Context/withMapping';
import WysiwygField from '../../WysiwygField';
import './style.scss';
var GenericFormElement = function GenericFormElement(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var className = props.className,
    title = props.title,
    required = props.required,
    description = props.description,
    fieldName = props.fieldName,
    touched = props.touched,
    error = props.error,
    children = props.children,
    displayRequiredIndicator = props.displayRequiredIndicator,
    errorId = props.errorId,
    descriptionId = props.descriptionId,
    _props$includeFieldSe = props.includeFieldSet,
    includeFieldSet = _props$includeFieldSe === void 0 ? false : _props$includeFieldSe,
    _props$descriptionAbo = props.descriptionAboveInput,
    descriptionAboveInput = _props$descriptionAbo === void 0 ? false : _props$descriptionAbo;
  return /*#__PURE__*/React.createElement("div", {
    className: error && touched ? "FormElement ".concat(className, " error") : "FormElement ".concat(className)
  }, title && !includeFieldSet && /*#__PURE__*/React.createElement("label", {
    htmlFor: fieldName
  }, title, !required && displayRequiredIndicator === 'optional' && /*#__PURE__*/React.createElement("span", {
    className: "FormElement__optional ".concat(className, "__optional")
  }, t(['form.optional', ' - optioneel'])), required && displayRequiredIndicator === 'required' && /*#__PURE__*/React.createElement("span", {
    className: "FormElement__required ".concat(className, "__required")
  }, t(['form.required', ' - vereist']))), description && descriptionAboveInput && /*#__PURE__*/React.createElement(WysiwygField, {
    id: descriptionId,
    property: "schema:text",
    html: description,
    className: "FormElement__description ".concat(className, "__description FormElement__description--above-input")
  }), /*#__PURE__*/React.createElement("div", {
    className: "FormElement__inner ".concat(className, "__inner")
  }, includeFieldSet && /*#__PURE__*/React.createElement("fieldset", {
    "aria-describedby": "".concat(errorId, " ").concat(descriptionId),
    "aria-invalid": Boolean(error && touched)
  }, title && /*#__PURE__*/React.createElement("legend", null, title, !required && displayRequiredIndicator === 'optional' && /*#__PURE__*/React.createElement("span", {
    className: "FormElement__optional ".concat(className, "__optional")
  }, t(['form.optional', ' - optioneel'])), required && displayRequiredIndicator === 'required' && /*#__PURE__*/React.createElement("span", {
    className: "FormElement__required ".concat(className, "__required")
  }, t(['form.required', ' - vereist']))), children), !includeFieldSet && children), description && !descriptionAboveInput && /*#__PURE__*/React.createElement(WysiwygField, {
    id: descriptionId,
    property: "schema:text",
    html: description,
    className: "FormElement__description ".concat(className, "__description")
  }), error && touched ? /*#__PURE__*/React.createElement("div", {
    id: errorId,
    className: "FormElement__error ".concat(className, "__error")
  }, error) : null);
};
export default withMapping(GenericFormElement);